export function mergeMassnahmeOptions(
  dbLabels: string[] | null,
  templateOptions: string[],
  currentValue: string,
): string[] {
  const base = dbLabels ?? templateOptions
  if (currentValue && !base.includes(currentValue)) {
    return [...base, currentValue]
  }
  return base
}
